import { render } from "./credits.vue?vue&type=template&id=17a0f73c&scoped=true"
import script from "./credits.vue?vue&type=script&lang=js"
export * from "./credits.vue?vue&type=script&lang=js"

import "./credits.vue?vue&type=style&index=0&id=17a0f73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a0f73c"]])

export default __exports__